<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content>
  <h3>{{ data.subtitle }}</h3>

  <mat-selection-list
    cdkDropList
    class="example-list"
    [(ngModel)]="data.selectedColumns"
    (cdkDropListDropped)="dropOnGroup($event)"
    >
    @for (column of data.columns; track column) {
      <mat-list-option
        cdkDrag
        [cdkDragDisabled]="!data.sortable"
        class="example-box"
        checkboxPosition="before"
        [value]="column.id"
        [disabled]="isColumnDisabled(column.id)"
        >
        <div class="flex-row">
          {{ column.label }}
          @if (data.sortable && !isColumnDisabled(column.id)) {
            <mat-icon class="drag-icon">drag_indicator</mat-icon>
          }
        </div>
      </mat-list-option>
    }
  </mat-selection-list>
</div>

<div mat-dialog-actions align="end">
  <mat-action-row style="width: 100%">
    <button mat-raised-button mat-dialog-close>Close</button>
    <button #focus mat-raised-button color="primary" (click)="onSave()">Save</button>
  </mat-action-row>
</div>
